export default __webpack_public_path__ + "static/media/(22).ffb0d5fd.jpeg";